<template>
  <text-box :label="`Spend by Touchpoint (${unit})`" icon="vector-point">
    <template v-slot:info-dialog>
      Projected KPI composition by media spend
    </template>
    <v-container fluid>
      <v-row>
        <v-col :cols="colsPerRow" v-for="channel in mix" :key="channel[0]">
          <marketing-spend-detail-channel :data="channel[1]" :total="data.budget" :code="channel[0]" :colors="colors"/>
        </v-col>
      </v-row>
    </v-container>
  </text-box>
</template>

<script>
import TextBox from '@/components/TextBox.vue'
import MarketingSpendDetailChannel from '@/components/simulationDetails/MarketingSpendDetailChannel.vue'

export default {
  data () {
    return {}
  },
  computed: {
    mix: function () {
      var sortable = []
      for (var key in this.data.mix) {
        sortable.push([key, this.data.mix[key]])
      }
      if (this.sort) {
        sortable.sort(function (a, b) {
          return b[1].invest - a[1].invest
        })
      }
      return sortable
    }
  },
  methods: {},
  props: {
    data: {
      type: Object,
      required: true
    },
    colors: {
      type: Object,
      required: false
    },
    colsPerRow: {
      type: Number,
      required: false,
      default: function () {
        return 6
      }
    },
    sort: {
      type: Boolean,
      required: false,
      default: function () {
        return true
      }
    },
    unit: {
      type: String,
      required: false,
      default: function () {
        return 'USD'
      }
    }
  },
  components: {
    TextBox,
    MarketingSpendDetailChannel
  }
}
</script>
